// extracted by mini-css-extract-plugin
module.exports =  {"exitTimeout":"1000ms","loader":"ZlOBWd","spinner":"SoYIl8","loaderSpin":"Vaffee","fadeOut":"foRPt0","loaderFadeOut":"SbSJIH"};